import classNames from 'classnames';
import styles from './Paragraph.module.scss';

export interface UI_ParagraphProps {
	children: React.ReactNode;
	className?: string;
	textAlignRight?: boolean;
	bold?: boolean;
}

export const UI_Paragraph = ({ children, className, textAlignRight, bold }: UI_ParagraphProps) => (
	<p className={classNames(styles.Paragraph, { [styles[`Paragraph___right`]]: textAlignRight, [styles[`Paragraph___bold`]]: bold }, className)}>
		{children}
	</p>
);
